import { Component, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Solutions from "@/pages/Solutions";
import Marketing from "@/pages/services/Marketing";
import Veluro from "@/pages/services/Veluro";
import Wellness from "@/pages/services/Wellness";
import Claims from "@/pages/services/Claims";
import Shipping from "@/pages/services/Shipping";
import Emerging from "@/pages/services/Emerging";
import Approach from "@/pages/Approach";
import About from "@/pages/About";
import BecomePartner from "@/pages/BecomePartner";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-ivory px-6 text-center">
          <div>
            <p className="font-serif text-2xl text-navy">Something went wrong.</p>
            <p className="mt-3 text-charcoal/70">Please refresh the page to continue.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function SmoothScroll() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);
  return null;
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <SmoothScroll />
        <ScrollToTop />
        <Navbar />
        <main id="main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/solutions/marketing-website-design" element={<Marketing />} />
            <Route path="/solutions/veluro-ai-marketing" element={<Veluro />} />
            <Route path="/solutions/employee-health-wellness" element={<Wellness />} />
            <Route path="/solutions/medical-claims-billing" element={<Claims />} />
            <Route path="/solutions/shipping-freight" element={<Shipping />} />
            <Route path="/solutions/emerging-opportunities" element={<Emerging />} />
            <Route path="/approach" element={<Approach />} />
            <Route path="/about" element={<About />} />
            <Route path="/become-a-partner" element={<BecomePartner />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/home" element={<Navigate to="/" replace />} />

            {/* Redirect mapping for existing service URLs */}
            <Route path="/Services/Core-Services/Employee-Health-Wellness" element={<Navigate to="/solutions/employee-health-wellness" replace />} />
            <Route path="/Services/Core-Services/Medical-Claims-Billing" element={<Navigate to="/solutions/medical-claims-billing" replace />} />
            <Route path="/Services/Core-Services/Shipping-Freight" element={<Navigate to="/solutions/shipping-freight" replace />} />
            <Route path="/Services/*" element={<Navigate to="/solutions" replace />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
